<template>
    <div>
        <v-card class="card--flex-toolbar" flat>
            <v-tabs color="grey lighten-3" v-model="current_tab" dark slider-color="grey darken-4">
                <v-tab ripple v-for="tab in tabs" :key="tab.href" :to="{name: tab.route_name}" class="grey--text text--darken-4 caption">{{tab.text}}</v-tab>
            </v-tabs>
        </v-card>
        <v-card v-if="isLoading" height="50vh">
            <v-content class="content-background">
                <v-container fluid fill-height>
                    <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4>
                        <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                    </v-flex>
                    </v-layout>
                </v-container>
            </v-content>
        </v-card >
        <router-view v-else
            :page.sync="page"
            :availableWidgets="availableWidgets"
        ></router-view>
    </div>
  </template>
  <script>
  import i18n from "@/i18n";
  import { mapState, mapGetters } from "vuex";
  export default {
    name: "CompanyRoot",
    components: {

    },
    data() {
      return {
        active: null,
        current_tab: 'overview',
        isLoading: false,
        tabs: [
            {
              text: i18n.t('admin.page.appearance.navigation.tabs.meta.data'),
              route_name: 'AdminPageRoot'
            },
            {
              text: i18n.t('admin.page.appearance.navigation.tabs.customize'),
              route_name: 'AdminPageManageWidgets'
            },
        ],
        page: null,
        availableWidgets: []
      };
    },
    created() {
      this.bootstrap();
    },
    computed: {
      ...mapGetters("company", {
          selected_company_id: "getSelected",
      }),
    },
    methods: {
      /**
       * Fetch all dependency of a page in parent
       */
      async bootstrap() {
        this.isLoading = true;
        await Promise.all([
            this.$store.dispatch("adminPage/get", {
              page_id: this.$route.params.page_id
            }),
            this.$store.dispatch("adminWidget/list")
        ])
        .then((responses) => {
            this.page = responses[0]
            this.availableWidgets = responses[1].widgets.data.filter(element => element.published===1)
        }).catch((error) => {
           this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error"
          });
        })
        .finally(() => {
          this.isLoading = false
        })
      },

    }
  };
  </script>
